export default function ApplicantRestrictedPage() {
  return (
    <div style={{ backgroundColor:"white", position: "absolute", top: 0, left: 0, padding: "40px", textAlign: "center", zIndex: 9999, height: "100%", width: "100%"}}>
      <h2>Access Restricted</h2>

      <p style={{ marginTop: "20px", fontSize: "18px" }}>
        We identified that you have an Applicant profile.  
        In this case, you must log in through the Applicant Portal.
      </p>

      <a
        href="/applicant-signin"
        style={{
          marginTop: "30px",
          display: "inline-block",
          padding: "12px 24px",
          background: "#007bff",
          color: "white",
          borderRadius: "6px",
          textDecoration: "none",
          fontSize: "16px"
        }}
      >
        Go to Applicant Portal
      </a>
    </div>
  );
}
